import { SortingField } from '@trucksmarter/shared';
import DallasSvgIconArrowDownwardOutlined from '@ui/Dallas/Icons/DallasSvgIconArrowDownwardOutlined';
import DallasSvgIconArrowUpwardOutlined from '@ui/Dallas/Icons/DallasSvgIconArrowUpwardOutlined';
import DallasSvgIconAttachMoneyOutlined from '@ui/Dallas/Icons/DallasSvgIconAttachMoneyOutlined';
import DallasSvgIconFlagOutlined from '@ui/Dallas/Icons/DallasSvgIconFlagOutlined';
import DallasSvgIconPercentOutlined from '@ui/Dallas/Icons/DallasSvgIconPercentOutlined';
import DallasSvgIconScheduleOutlined from '@ui/Dallas/Icons/DallasSvgIconScheduleOutlined';
import DallasSvgIconStarOutlined from '@ui/Dallas/Icons/DallasSvgIconStarOutlined';
import { DallasSortingOptionItem } from '@ui/Dallas/Forms/dallas-sorting';

export const LOADBOARD_RPM_SORT_OPTIONS: DallasSortingOptionItem<SortingField>[] =
  [
    {
      value: {
        field: 'ratePerMile',
        order: 'desc',
      },
      label: 'Rate per mile',
      description: 'Highest RpM',
      addOnStart: <DallasSvgIconPercentOutlined />,
    },
  ];

export const LOADBOARD_CRETED_AT_SORT_OPTIONS: DallasSortingOptionItem<SortingField>[] =
  [
    {
      value: {
        field: 'createdAt',
        order: 'desc',
      },
      label: 'Age',
      description: 'Newest to oldest',
      addOnStart: <DallasSvgIconScheduleOutlined />,
    },
  ];

export const LOADBOARD_PRICE_SORT_OPTIONS: DallasSortingOptionItem<SortingField>[] =
  [
    {
      value: {
        field: 'price',
        order: 'desc',
      },
      label: 'Price',
      description: 'Highest price',
      addOnStart: <DallasSvgIconAttachMoneyOutlined />,
    },
  ];

export const LOADBOARD_DISTANCE_SORT_OPTIONS: DallasSortingOptionItem<SortingField>[] =
  [
    {
      value: {
        field: 'distance',
        order: 'desc',
      },
      label: 'Distance',
      description: 'High to low',
      addOnStart: <DallasSvgIconArrowDownwardOutlined />,
    },
    {
      value: {
        field: 'distance',
        order: 'asc',
      },
      label: 'Distance',
      description: 'Low to high',
      addOnStart: <DallasSvgIconArrowUpwardOutlined />,
    },
  ];

export const LOADBOARD_DEADHEAD_SORT_OPTIONS: DallasSortingOptionItem<SortingField>[] =
  [
    {
      value: {
        field: 'deadheadMiles',
        order: 'asc',
      },
      label: 'Deadhead',
      description: 'Shortest distance',
      addOnStart: <DallasSvgIconFlagOutlined />,
    },
  ];

const LOADBOARD_SORT_OPTIONS: DallasSortingOptionItem<SortingField>[] = [
  {
    value: {
      field: 'recommended',
      order: 'desc',
    },
    label: 'Recommended',
    description: 'Personalized loads',
    addOnStart: <DallasSvgIconStarOutlined />,
  },
  ...LOADBOARD_RPM_SORT_OPTIONS,
  ...LOADBOARD_CRETED_AT_SORT_OPTIONS,
  ...LOADBOARD_PRICE_SORT_OPTIONS,
  ...LOADBOARD_DISTANCE_SORT_OPTIONS,
  ...LOADBOARD_DEADHEAD_SORT_OPTIONS,
];

export default LOADBOARD_SORT_OPTIONS;
